import { EqlField } from 'generated/graphql';
import { isEqlFieldCohorts } from './isEqlFieldCohorts';

export const getMetadataQBFieldFromEqlField = (eqlField: EqlField) => {
  if (isEqlFieldCohorts(eqlField.field)) {
    return 'common.metadata.common.cohorts';
  }

  if (!eqlField.detail?.metadata?.source) {
    return;
  }
  return `${eqlField.detail.metadata.source}.${eqlField.field}`;
};
